import { useTranslation } from 'react-i18next'

import { LandingDemoModalTrigger } from '@/features/demos/LandingDemoModalTrigger'
import type { LandingPage } from '@tipi/shared'

type VoiceDemoModalTriggerProps = {
    landingPage: LandingPage
    className?: string
}

export function VoiceDemoModalTrigger({ landingPage, className }: VoiceDemoModalTriggerProps) {
    const { t } = useTranslation()

    return (
        <LandingDemoModalTrigger
            demoId='escandallo-voz'
            landingPage={landingPage}
            trackEvent='How It Works Voice Demo'
            ctaLabel={t('foodCost.howItWorks.steps.1.watchDemo')}
            title={t('foodCost.howItWorks.voiceDemoTitle')}
            closeLabel={t('foodCost.howItWorks.voiceDemoClose')}
            className={className}
        />
    )
}
